
export enum UserRole {
  MEMBER = 'MEMBER',
  PASTOR = 'PASTOR',
  ADMIN = 'ADMIN',
  CHURCH_REP = 'CHURCH_REP'
}

export enum BibleVersion {
  NIV = 'NIV',
  KJV = 'KJV',
  ESV = 'ESV',
  NASB = 'NASB',
  NLT = 'NLT'
}

export interface User {
  id: string;
  name: string;
  email: string;
  avatarUrl: string;
  role: UserRole;
  churchId?: string; // The church they serve
  voluntaryCall?: string; // Equivalent to Job Title
  favoriteBiblePassage?: string;
  location: string;
  language: string;
  bio?: string;
  bannerUrl?: string;
  connections: string[]; // List of connected user IDs
}

export interface Church {
  id: string;
  name: string;
  description: string;
  logoUrl: string;
  bannerUrl: string;
  website: string;
  address: string;
  country: string;
  region: string;
  memberCount: number;
  stripeConnected: boolean;
  admins: string[]; // User IDs
  worshipSongs: string[]; // List of songs usually sung
}

export interface Comment {
  id: string;
  authorId: string;
  content: string;
  timestamp: number;
}

export interface Post {
  id: string;
  authorId: string;
  churchId?: string; // If posted by the church page
  content: string; // Rich text / emojis
  imageUrl?: string;
  videoUrl?: string;
  bibleCitation?: {
    reference: string;
    text: string;
  };
  timestamp: number;
  likes: string[]; // List of User IDs
  comments: Comment[]; // List of Comment objects
}

export interface Sermon {
  id: string;
  churchId: string;
  title: string;
  preacher: string;
  date: string;
  description: string;
  videoUrl: string;
}

export interface ChurchEvent {
  id: string;
  churchId: string;
  title: string;
  description: string;
  date: string;
  location: string;
  imageUrl?: string;
  guestSpeakers?: string[]; // Pastors from other churches
  attendeeCount: number;
  price?: number; // 0 or undefined for free
}

export interface PrayerGroup {
  id: string;
  churchId: string;
  name: string;
  description: string;
  meetingSchedule: string; // e.g., "Weekly on Tuesdays at 7PM"
  leaderId: string;
  members: string[];
}

export interface Cause {
  id: string;
  title: string;
  description: string;
  type: 'FOOD' | 'HOUSING' | 'JOB' | 'OTHER';
  urgency: 'LOW' | 'MEDIUM' | 'HIGH';
  contactInfo: string;
  authorId: string;
  churchId?: string;
  category: 'REQUEST' | 'OFFER'; // New field
}

export interface Message {
  id: string;
  senderId: string;
  receiverId: string;
  content: string;
  timestamp: number;
  isRead: boolean;
}
